import { __assign } from "tslib";
import * as React from 'react';
function IconLockSizeXs(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 12 12" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.6 4.333h-.8c-.442 0-.8.373-.8.834v5c0 .46.358.833.8.833h6.4c.442 0 .8-.373.8-.833v-5c0-.46-.358-.834-.8-.834h-.8V3.5C8.4 2.12 7.325 1 6 1S3.6 2.12 3.6 3.5v.833zm.8 0h3.2V3.5c0-.92-.716-1.667-1.6-1.667-.884 0-1.6.747-1.6 1.667v.833zm.4 3.334c0-.69.537-1.25 1.2-1.25.663 0 1.2.56 1.2 1.25s-.537 1.25-1.2 1.25c-.663 0-1.2-.56-1.2-1.25z" })));
}
export default IconLockSizeXs;
